import script from "./GstPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./GstPricing.vue?vue&type=script&setup=true&lang=js"

import "./GstPricing.vue?vue&type=style&index=0&id=163763da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163763da"]])

export default __exports__